module.exports = __webpack_public_path__ + "media/images/about__header-md-4697fb81f32bfbc80ad7c050c667674e.jpg";